import type { AnalysisTarget } from "./analysis-target";

/** Canonical path の構築に使う未エンコードの言語と workspace ID。エンコードは builder が行う。 */
export type AnalysisTargetPathContext = {
  lang: string;
  workspaceId: string;
};

/** 未エンコードの path context と、リンクを開く frontend 環境の origin。 */
export type AnalysisTargetNavigationContext = AnalysisTargetPathContext & {
  frontendOrigin: string;
};

/**
 * application が生成した canonical path を、同じ環境の絶対 URL に変換する。
 *
 * @throws `context.frontendOrigin` が絶対 URL として不正な場合。
 */
export function buildNavigationUrl(
  navigationPath: string,
  context: AnalysisTargetNavigationContext,
): string {
  return new URL(navigationPath, context.frontendOrigin).toString();
}

/**
 * 分析対象の canonical route を組み立てる。
 *
 * View route に中間の `/view/` segment は存在しない。この関数を UI と AI context
 * の共通境界にして、表示用リンクと model へ渡す path の形式を一致させる。
 */
export function buildAnalysisTargetNavigationPath(
  target: AnalysisTarget,
  context: AnalysisTargetPathContext,
): string {
  const lang = encodeURIComponent(context.lang);
  const workspaceId = encodeURIComponent(context.workspaceId);
  const projectId = encodeURIComponent(target.projectId);
  const domain =
    target.projectType === "SearchAnalyticsProject"
      ? "sa"
      : target.projectType === "UserAnalyticsProject"
        ? "ua"
        : "iw";
  const detailId =
    target.projectType === "IndexWorkerProject" ? target.iwId : target.viewId;
  const projectPath = `/${lang}/${workspaceId}/${domain}/${projectId}`;
  return detailId
    ? `${projectPath}/${encodeURIComponent(detailId)}`
    : projectPath;
}
